import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, computed, inject, PLATFORM_ID, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { Subscription } from 'rxjs';
import { AuthService, UserRole } from '../../core/services/auth.service';
import { AppState } from '../../core/store';
import { getSettingsStore } from '../../core/store/selectors/settings.selector';
import { AdminHeaderComponent } from '../../shared/components/admin-header/admin-header.component';
import { AdminSidemenuComponent } from '../../shared/components/admin-sidemenu/admin-sidemenu.component';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NzLayoutModule,
    AdminHeaderComponent,
    AdminSidemenuComponent,
  ],
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.less',
})
export class AdminComponent {
  store = inject(Store<AppState>);
  authService = inject(AuthService);
  private readonly platformId = inject(PLATFORM_ID);

  settingsStoreSub?: Subscription;

  isCollapsed = false;
  readonly isBrowser = signal(false);
  readonly UserRole = UserRole;
  readonly isNoRoleUser = computed(
    () =>
      this.isBrowser() &&
      this.authService.isLoggedIn() &&
      this.authService.role() === UserRole.None,
  );

  ngOnInit(): void {
    this.isBrowser.set(isPlatformBrowser(this.platformId));

    this.settingsStoreSub = this.store.pipe(select(getSettingsStore)).subscribe((settingsStore) => {
      this.isCollapsed = settingsStore.sideMenuCollapsedState;
    });
  }

  ngOnDestroy(): void {
    this.settingsStoreSub?.unsubscribe();
  }
}
